/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * macweb API
 * OpenAPI spec version: 0.4.45
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DownloadRegulatoryReportArchiveParams,
  ErrorResponse,
  GenerateReportRequest,
  GetRegulatoryReportStatusParams,
  ImportRegulatoryReportBody,
  ListRegulatoryReportsParams,
  MonthlyStatusResponse,
  RegulatoryReportListResponse,
  RegulatoryReportResponse
} from '.././model';

import { customInstance } from '../../orvalMutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary List regulatory reports
 */
export const listRegulatoryReports = (
    params?: ListRegulatoryReportsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RegulatoryReportListResponse>(
      {url: `/api/regulatory-reports`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListRegulatoryReportsQueryKey = (params?: ListRegulatoryReportsParams,) => {
    return [
    `/api/regulatory-reports`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListRegulatoryReportsQueryOptions = <TData = Awaited<ReturnType<typeof listRegulatoryReports>>, TError = ErrorResponse>(params?: ListRegulatoryReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRegulatoryReports>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRegulatoryReportsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRegulatoryReports>>> = ({ signal }) => listRegulatoryReports(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRegulatoryReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRegulatoryReportsQueryResult = NonNullable<Awaited<ReturnType<typeof listRegulatoryReports>>>
export type ListRegulatoryReportsQueryError = ErrorResponse


export function useListRegulatoryReports<TData = Awaited<ReturnType<typeof listRegulatoryReports>>, TError = ErrorResponse>(
 params: undefined |  ListRegulatoryReportsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRegulatoryReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRegulatoryReports>>,
          TError,
          Awaited<ReturnType<typeof listRegulatoryReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRegulatoryReports<TData = Awaited<ReturnType<typeof listRegulatoryReports>>, TError = ErrorResponse>(
 params?: ListRegulatoryReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRegulatoryReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRegulatoryReports>>,
          TError,
          Awaited<ReturnType<typeof listRegulatoryReports>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRegulatoryReports<TData = Awaited<ReturnType<typeof listRegulatoryReports>>, TError = ErrorResponse>(
 params?: ListRegulatoryReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRegulatoryReports>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List regulatory reports
 */

export function useListRegulatoryReports<TData = Awaited<ReturnType<typeof listRegulatoryReports>>, TError = ErrorResponse>(
 params?: ListRegulatoryReportsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRegulatoryReports>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRegulatoryReportsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Download a regulatory report file
 */
export const downloadRegulatoryReport = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Blob>(
      {url: `/api/regulatory-reports/${id}/download`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }
  



export const getDownloadRegulatoryReportQueryKey = (id?: string,) => {
    return [
    `/api/regulatory-reports/${id}/download`
    ] as const;
    }

    
export const getDownloadRegulatoryReportQueryOptions = <TData = Awaited<ReturnType<typeof downloadRegulatoryReport>>, TError = ErrorResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadRegulatoryReport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadRegulatoryReportQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadRegulatoryReport>>> = ({ signal }) => downloadRegulatoryReport(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadRegulatoryReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadRegulatoryReportQueryResult = NonNullable<Awaited<ReturnType<typeof downloadRegulatoryReport>>>
export type DownloadRegulatoryReportQueryError = ErrorResponse


export function useDownloadRegulatoryReport<TData = Awaited<ReturnType<typeof downloadRegulatoryReport>>, TError = ErrorResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadRegulatoryReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadRegulatoryReport>>,
          TError,
          Awaited<ReturnType<typeof downloadRegulatoryReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadRegulatoryReport<TData = Awaited<ReturnType<typeof downloadRegulatoryReport>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadRegulatoryReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadRegulatoryReport>>,
          TError,
          Awaited<ReturnType<typeof downloadRegulatoryReport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadRegulatoryReport<TData = Awaited<ReturnType<typeof downloadRegulatoryReport>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadRegulatoryReport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download a regulatory report file
 */

export function useDownloadRegulatoryReport<TData = Awaited<ReturnType<typeof downloadRegulatoryReport>>, TError = ErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadRegulatoryReport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadRegulatoryReportQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Get monthly completeness status for regulatory reports
 */
export const getRegulatoryReportStatus = (
    params: GetRegulatoryReportStatusParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MonthlyStatusResponse>(
      {url: `/api/regulatory-reports/status`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetRegulatoryReportStatusQueryKey = (params?: GetRegulatoryReportStatusParams,) => {
    return [
    `/api/regulatory-reports/status`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetRegulatoryReportStatusQueryOptions = <TData = Awaited<ReturnType<typeof getRegulatoryReportStatus>>, TError = ErrorResponse>(params: GetRegulatoryReportStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegulatoryReportStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegulatoryReportStatusQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegulatoryReportStatus>>> = ({ signal }) => getRegulatoryReportStatus(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegulatoryReportStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRegulatoryReportStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getRegulatoryReportStatus>>>
export type GetRegulatoryReportStatusQueryError = ErrorResponse


export function useGetRegulatoryReportStatus<TData = Awaited<ReturnType<typeof getRegulatoryReportStatus>>, TError = ErrorResponse>(
 params: GetRegulatoryReportStatusParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegulatoryReportStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegulatoryReportStatus>>,
          TError,
          Awaited<ReturnType<typeof getRegulatoryReportStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRegulatoryReportStatus<TData = Awaited<ReturnType<typeof getRegulatoryReportStatus>>, TError = ErrorResponse>(
 params: GetRegulatoryReportStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegulatoryReportStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegulatoryReportStatus>>,
          TError,
          Awaited<ReturnType<typeof getRegulatoryReportStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRegulatoryReportStatus<TData = Awaited<ReturnType<typeof getRegulatoryReportStatus>>, TError = ErrorResponse>(
 params: GetRegulatoryReportStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegulatoryReportStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get monthly completeness status for regulatory reports
 */

export function useGetRegulatoryReportStatus<TData = Awaited<ReturnType<typeof getRegulatoryReportStatus>>, TError = ErrorResponse>(
 params: GetRegulatoryReportStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegulatoryReportStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRegulatoryReportStatusQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Download ZIP archive of reports for a month
 */
export const downloadRegulatoryReportArchive = (
    params: DownloadRegulatoryReportArchiveParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Blob>(
      {url: `/api/regulatory-reports/archive`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }
  



export const getDownloadRegulatoryReportArchiveQueryKey = (params?: DownloadRegulatoryReportArchiveParams,) => {
    return [
    `/api/regulatory-reports/archive`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getDownloadRegulatoryReportArchiveQueryOptions = <TData = Awaited<ReturnType<typeof downloadRegulatoryReportArchive>>, TError = ErrorResponse>(params: DownloadRegulatoryReportArchiveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadRegulatoryReportArchive>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadRegulatoryReportArchiveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadRegulatoryReportArchive>>> = ({ signal }) => downloadRegulatoryReportArchive(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadRegulatoryReportArchive>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DownloadRegulatoryReportArchiveQueryResult = NonNullable<Awaited<ReturnType<typeof downloadRegulatoryReportArchive>>>
export type DownloadRegulatoryReportArchiveQueryError = ErrorResponse


export function useDownloadRegulatoryReportArchive<TData = Awaited<ReturnType<typeof downloadRegulatoryReportArchive>>, TError = ErrorResponse>(
 params: DownloadRegulatoryReportArchiveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadRegulatoryReportArchive>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadRegulatoryReportArchive>>,
          TError,
          Awaited<ReturnType<typeof downloadRegulatoryReportArchive>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadRegulatoryReportArchive<TData = Awaited<ReturnType<typeof downloadRegulatoryReportArchive>>, TError = ErrorResponse>(
 params: DownloadRegulatoryReportArchiveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadRegulatoryReportArchive>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadRegulatoryReportArchive>>,
          TError,
          Awaited<ReturnType<typeof downloadRegulatoryReportArchive>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDownloadRegulatoryReportArchive<TData = Awaited<ReturnType<typeof downloadRegulatoryReportArchive>>, TError = ErrorResponse>(
 params: DownloadRegulatoryReportArchiveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadRegulatoryReportArchive>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download ZIP archive of reports for a month
 */

export function useDownloadRegulatoryReportArchive<TData = Awaited<ReturnType<typeof downloadRegulatoryReportArchive>>, TError = ErrorResponse>(
 params: DownloadRegulatoryReportArchiveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof downloadRegulatoryReportArchive>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDownloadRegulatoryReportArchiveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Generate a regulatory report
 */
export const generateRegulatoryReport = (
    generateReportRequest: GenerateReportRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RegulatoryReportResponse>(
      {url: `/api/admin/regulatory-reports/generate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generateReportRequest, signal
    },
      options);
    }
  


export const getGenerateRegulatoryReportMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateRegulatoryReport>>, TError,{data: GenerateReportRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof generateRegulatoryReport>>, TError,{data: GenerateReportRequest}, TContext> => {

const mutationKey = ['generateRegulatoryReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateRegulatoryReport>>, {data: GenerateReportRequest}> = (props) => {
          const {data} = props ?? {};

          return  generateRegulatoryReport(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateRegulatoryReportMutationResult = NonNullable<Awaited<ReturnType<typeof generateRegulatoryReport>>>
    export type GenerateRegulatoryReportMutationBody = GenerateReportRequest
    export type GenerateRegulatoryReportMutationError = ErrorResponse

    /**
 * @summary Generate a regulatory report
 */
export const useGenerateRegulatoryReport = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateRegulatoryReport>>, TError,{data: GenerateReportRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateRegulatoryReport>>,
        TError,
        {data: GenerateReportRequest},
        TContext
      > => {

      const mutationOptions = getGenerateRegulatoryReportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Import external regulatory report (M2M)
 */
export const importRegulatoryReport = (
    importRegulatoryReportBody: ImportRegulatoryReportBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`file`, importRegulatoryReportBody.file)
if(importRegulatoryReportBody.type !== undefined) {
 formData.append(`type`, importRegulatoryReportBody.type)
 }

      return customInstance<RegulatoryReportResponse>(
      {url: `/api/admin/regulatory-reports/import`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }
  


export const getImportRegulatoryReportMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importRegulatoryReport>>, TError,{data: ImportRegulatoryReportBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof importRegulatoryReport>>, TError,{data: ImportRegulatoryReportBody}, TContext> => {

const mutationKey = ['importRegulatoryReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importRegulatoryReport>>, {data: ImportRegulatoryReportBody}> = (props) => {
          const {data} = props ?? {};

          return  importRegulatoryReport(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ImportRegulatoryReportMutationResult = NonNullable<Awaited<ReturnType<typeof importRegulatoryReport>>>
    export type ImportRegulatoryReportMutationBody = ImportRegulatoryReportBody
    export type ImportRegulatoryReportMutationError = ErrorResponse

    /**
 * @summary Import external regulatory report (M2M)
 */
export const useImportRegulatoryReport = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importRegulatoryReport>>, TError,{data: ImportRegulatoryReportBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof importRegulatoryReport>>,
        TError,
        {data: ImportRegulatoryReportBody},
        TContext
      > => {

      const mutationOptions = getImportRegulatoryReportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    